import { graphql } from 'react-relay';

export const authButtonFragment = graphql`
    fragment AuthButton_authLink on IconLink {
        label
        url
        iconUrl
    }
`;
